﻿// debounce example function https://remysharp.com/2010/07/21/throttling-function-calls#comment-497362
export const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
};